import axios from "axios"
class AppUtils {
    /**
     * 上传图片
     */
    static uploadImage(count, callback) {
        Bridge.callNavite('action_upload_image', { count: count || 1 }, (res) => {
            let list = JSON.parse(res)
            callback && callback(list.map(x => x.url))
        })
    }
    /**
     * 获取token
     */
    static getToken(callback) {
        Bridge.callNavite('getLoginInfo', {}, (res) => {
            try {
                let data = JSON.parse(res)
                callback && callback(data.token)
            } catch (error) {
                callback && callback(res)
            }
        })
    }
    /**
     * 打开新链接
     * @param {*} url 传入完整链接
     */
    static openWebUrl(url) {
        if (Bridge.isAndroid()) {
            Bridge.callNavite('action_open_web', { url: url })
            return
        }
        Bridge.callNavite('action_open_system_web', { url: url })
    }
    

    static getAppToken() {
      return new Promise((resolve, reject) => {
        if (!Bridge.isInNative()) {
          resolve && resolve({ token: 'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2NvZGUiOiJRRDAwMDAwMDAxIiwidXNlcl9pZCI6IjEiLCJ1c2VyX2tleSI6IjUzZTJkOTA0LTEzYzAtNDg0MC05YWY3LTU2MTQ0YmViMzRhNyIsInVzZXJuYW1lIjoiYWRtaW4ifQ.2dQIbfIGeoPrTC2UIMXe3uneP5NqYlcowh4-QFhxURvGH457oekUtBX9TAI-dPvVKOg10YYCRkhF-t4zvZbrvw' })
            return
        }
        Bridge.callNavite("getLoginInfo", {}, (data) => {
            data = JSON.parse(data)
            resolve && resolve(data)
        })
      })
    }

    static getBaseUrl() {
      return new Promise((resolve, reject) => {
          if (!Bridge.isInNative()) {
              resolve('http://58.250.18.47:18081')
          }
          Bridge.callNavite("getAppConfig", {}, (data) => {
              data = JSON.parse(data)
              resolve(data.baseUrl)
          })
      })
    }

    static getUserInfo(callback) {
      this.getBaseUrl().then(baseUrl => {
          // console.log('baseUrl====', baseUrl)
          this.getAppToken().then(token => {
              axios.get(baseUrl + '/system/user/getInfo', {
                  headers: {
                      'Authorization': token.token
                  }
              }).then(res => {
                  if (res.data.code === 200) {
                      callback && callback(res.data.user || {})
                  } else {
                      throw new Error(res.data.msg || '获取用户信息失败')
                  }
              })
          })
      })
    }

    static isInNative() {
      return Bridge.isInNative()
    }
}

class Bridge {
    constructor() { }
    static isAndroid() {
        return (
            navigator.userAgent.indexOf("Android") > -1 ||
            navigator.userAgent.indexOf("Adr") > -1
        );
    }

    static isiOS() {
        return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //这是必须要写的，用来创建一些设置
    }

    static setupWebViewJavascriptBridge(callback) {
        //Android使用

        if (this.isAndroid()) {
            if (window.WebViewJavascriptBridge) {
                callback(window.WebViewJavascriptBridge);
            } else {
                document.addEventListener(
                    "WebViewJavascriptBridgeReady",
                    (event) => {
                        if (window.onWebViewJavascriptBridgeReady)
                            window.onWebViewJavascriptBridgeReady(
                                (window.__bridge = WebViewJavascriptBridge)
                            );
                        callback(WebViewJavascriptBridge);
                    },
                    false
                );
            }
            sessionStorage.phoneType = "android";
        }
        //iOS使用
        if (this.isiOS()) {
            if (window.WebViewJavascriptBridge) {
                return callback(window.WebViewJavascriptBridge);
            }
            if (window.WVJBCallbacks) {
                return window.WVJBCallbacks.push(callback);
            }

            window.WVJBCallbacks = [callback];
            var WVJBIframe = document.createElement("iframe");

            WVJBIframe.style.display = "none";

            WVJBIframe.src = "wvjbscheme://__BRIDGE_LOADED__";

            document.documentElement.appendChild(WVJBIframe);

            setTimeout(() => {
                document.documentElement.removeChild(WVJBIframe);
            }, 0);

            sessionStorage.phoneType = "ios";
        }
    }

    static initAndroid() {
        if (this.isAndroid()) {
            //初始化
            this.setupWebViewJavascriptBridge((bridge) => {
                bridge.init((message, responseCallback) => {
                    var data = { "Javascript Responds": "Wee!" };
                    responseCallback(data);
                });

                bridge.registerHandler("functionInJs", function (
                    data,
                    responseCallback
                ) {
                    bridgeLog("指定接收收到来自Java数据： " + data);
                    var responseData = "指定接收收到来自Java的数据，回传数据给你";
                    responseCallback(responseData);
                });
            });
        }
    }

    static callHandler(name, data, callback) {
        this.setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(name, data, callback);
        });
    }

    static registerhandler(name, callback) {
        this.setupWebViewJavascriptBridge(function (bridge) {
            bridge.registerHandler(name, function (data, responseCallback) {
                callback(data, responseCallback);
            });
        });
    }

    static callNavite(name, params, callback) {
        if (!this.isInNative()) {
            callback && callback('请在app内打开')
            return
        }
        this.callHandler(
            "callNavite",
            {
                action: name,
                params: params,
            },
            callback
        );
    }

    static isInNative() {
        let ua = navigator.userAgent.toLowerCase();
        let result = ua.match(/qdsdapp/i)
        if (result && result[0] === 'qdsdapp') {
            return true
        }
        return false
    }
}
Bridge.initAndroid();
export { Bridge, AppUtils };


// WEBPACK FOOTER //
// ./src/utils/bridge.js